import { FC, PropsWithChildren } from 'react';

import { PageLoader } from '@/components/shared/loaders/PageLoader';
import { useLegacySavedFiltersMigration } from '@/components/shared/SavedFilters';

/**
 * Moves Saved Filters written before the storage key carried an owner under the signed-in user,
 * once identity has resolved and before any route renders.
 *
 * It holds the routes rather than running alongside them because the Saved Filters store cache is
 * keyed by storage key and never evicts: a view that mounts first would hold a store built from
 * the pre-migration key, and the migrated presets would not appear until the next page load. It
 * sits as deep as that allows — flags, error reporting and analytics start without waiting on a
 * localStorage pass — and the gateway above is already showing this loader, so the one commit it
 * costs is not visible.
 */
export const SavedFiltersMigrationGateway: FC<PropsWithChildren> = ({ children }) => {
  const hasMigrationSettled = useLegacySavedFiltersMigration();

  if (!hasMigrationSettled) {
    return <PageLoader />;
  }

  return <>{children}</>;
};
